import React from 'react';
import useBasket from '../../../../hooks/use-basket/use-basket';
import './addToBasket.scss';

const AddToBasketCue = ({productId}: propTypes) => {
  const basket: any = useBasket();
  const isInBasket = basket.items().map((item) => item.id === productId);

  const removeItem = () => {
    // remove item from basket based on productID
    const index = basket.items().indexOf(productId);
    basket.items().splice(index, 1);
  };

  return (
    <div className="customerCue--container">
      {isInBasket.length > 0 && (
        <>
          <div className="customerCue--notification">
            <span className="customerCue--tick">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  d="M1.73 12.91l6.37 6.37L22.79 4.59"
                />
              </svg>{' '}
              Added to basket
            </span>
          </div>

          <a href="#" onClick={removeItem}>
            Remove
          </a>
        </>
      )}
    </div>
  );
};

interface propTypes {
  productId: number;
}

export default AddToBasketCue;
